<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ asset_maintenance_schedule.id ? 'Edit ' : 'Create ' }} Maintenance Schedule</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">

      <div class="col-12 col-xl-6">

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Title</mat-label>
              <input
                matInput
                placeholder="Title"
                [(ngModel)]="asset_maintenance_schedule.title"
                name="title"
                type="text"
                required
                #title />
              <mat-hint>Please enter a maintenance schedule title.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Schedule Mode</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_schedule.schedule_mode"
                [disabled]="true"
                required
                name="schedule_mode"
                aria-label="Select the mode for this maintenance schedule.">
                <mat-option
                  *ngFor="let mode of scheduleModeOptions"
                  [value]="mode.value">
                  {{ mode.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select the mode for this schedule.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Default Priority</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_schedule.default_priority"
                required
                name="default_priority"
                aria-label="Select the default priority for this maintenance schedule.">
                <mat-option
                  *ngFor="let priority of priorityOptions"
                  [value]="priority.value">
                  {{ priority.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select the default priority for maintenance records created from this schedule.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Maintenance Type</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_schedule.maintenance_type"
                required
                name="maintenance_type"
                aria-label="Select the maintenance type.">
                <mat-option
                  *ngFor="let maintenance_type of maintenanceTypeOptions"
                  [value]="maintenance_type.value">
                  {{ maintenance_type.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select the type of maintenance to be scheduled.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6" *ngIf="asset_maintenance_schedule.maintenance_type === 'other'">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Other Maintenance Type</mat-label>
              <input
                matInput
                placeholder="Other Maintenance Type"
                [(ngModel)]="asset_maintenance_schedule.maintenance_type_other"
                name="maintenance_type_other"
                type="text"
                required
                maxlength="255" />
              <mat-hint>Enter the maintenance type when Other is selected.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Description"
                [(ngModel)]="asset_maintenance_schedule.description"
                name="description"
                id="description">
              </textarea>
              <mat-hint>Enter a description for the maintenance schedule.</mat-hint>
            </mat-form-field>
          </div>
        </div>

      </div>

      <div class="col-12 col-xl-6">

        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset_maintenance_schedule.enabled" name="enable_usage_logs">
              Schedule {{ asset_maintenance_schedule.enabled ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Enable or disable this maintenance schedule.</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset_maintenance_schedule.is_recurring" name="is_recurring">
              Recurring {{ asset_maintenance_schedule.is_recurring ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Enable to repeat this maintenance schedule based on the configured recurrence.</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset_maintenance_schedule.auto_create" name="auto_create">
              Auto Create Maintenance Record {{ asset_maintenance_schedule.auto_create ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Enable to automatically create a maintenance record before this schedule becomes due.</mat-hint>
          </div>
        </div>

        <div class="row" *ngIf="!asset_maintenance_schedule.is_recurring">
          <div class="col-12 col-md-6">
            <mat-slide-toggle [(ngModel)]="asset_maintenance_schedule.is_all_day" name="is_all_day" (change)="onAllDayChange()">
              All Day {{ asset_maintenance_schedule.is_all_day ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">When All Day is enabled, the selected next due at times are ignored and only the selected date is used.</mat-hint>
          </div>
          <div class="col-12 col-md-6">
            <app-datetime-picker
              [selectedDateTime]="nextDueAtDateTime"
              [isRequired]="true"
              [pickerName]="'nextDueAtDateTime'"
              [min]="today"
              [label]="'Next Due At'"
              [hint]="'Use the calendar icon to select the schedule next due date and time.'"
              [selectTooltip]="'Select the schedule next due date and time.'"
              [removeTooltip]="'Clear the schedule next due date and time.'"
              [classes]="'full-width mb-3'"
              (pickerDetailsOutput)="getOutputNextDueDateTimeDetails($event)"></app-datetime-picker>
            </div>
        </div>

        <div class="row" *ngIf="!asset_maintenance_schedule.is_recurring && !asset_maintenance_schedule.is_all_day">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Duration Unit</mat-label>
              <mat-select
                [(ngModel)]="duration_unit"
                name="duration_unit"
                (selectionChange)="onDurationChange()">
                <mat-option
                  *ngFor="let unit of schedulerService.durationUnits"
                  [value]="unit.key">
                  {{ unit.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select whether the duration is measured in minutes, hours, or days.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field
              class="full-width mb-3"
              appearance="outline"
              subscriptSizing="dynamic">
              <mat-label>Duration</mat-label>
              <input
                matInput
                type="number"
                min="1"
                [(ngModel)]="duration_value"
                name="duration_value"
                (ngModelChange)="onDurationChange()"
                (blur)="onDurationValueBlur($event)">
              <span matSuffix class="mr-2">
                <ng-container [ngSwitch]="duration_unit">
                  <span *ngSwitchCase="'minutes'">minute(s)</span>
                  <span *ngSwitchCase="'hours'">hour(s)</span>
                  <span *ngSwitchCase="'days'">day(s)</span>
                </ng-container>
              </span>
              <mat-hint>Enter how long the scheduled maintenance is expected to last.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="asset_maintenance_schedule.auto_create">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Auto Create Lead Time Unit</mat-label>
              <mat-select
                [(ngModel)]="asset_maintenance_schedule.auto_create_lead_time_unit"
                name="auto_create_lead_time_unit"
                required>
                <mat-option *ngFor="let unit of autoCreateLeadTimeUnitOptions" [value]="unit.value">
                  {{ unit.label }}
                </mat-option>
              </mat-select>
              <mat-hint>Select whether the auto create lead time is measured in hours, days, or weeks.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Auto Create Lead Time</mat-label>
              <input
                matInput
                type="number"
                min="0"
                placeholder="0.00"
                [(ngModel)]="asset_maintenance_schedule.auto_create_lead_time_value"
                (blur)="onAutoCreateLeadTimeValueBlur($event)"
                name="auto_create_lead_time_value"
                required>
              <span matSuffix class="mr-2">
                <ng-container [ngSwitch]="asset_maintenance_schedule.auto_create_lead_time_unit">
                  <span *ngSwitchCase="'hours'">hour(s)</span>
                  <span *ngSwitchCase="'days'">day(s)</span>
                  <span *ngSwitchCase="'weeks'">week(s)</span>
                </ng-container>
              </span>
              <mat-hint>Enter how long before the next due date the maintenance record should be created.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Notes</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Notes"
                [(ngModel)]="asset_maintenance_schedule.notes"
                name="notes"
                id="notes">
              </textarea>
              <mat-hint>Enter any notes for the maintenance schedule.</mat-hint>
            </mat-form-field>
          </div>
        </div>

      </div>

    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <ng-container *ngIf="asset_maintenance_schedule.is_recurring">
      <div class="d-flex align-items-center flex-wrap mb-2">
        <button
          mat-raised-button
          class="my-2 ml-1 mr-2"
          type="button"
          color="secondary"
          id="scheduler_button"
          (click)="onScheduler()"
          [matBadge]="asset_maintenance_schedule.schedule_start_at ? '1' : '0'"
          matTooltip="Configure the recurring schedule for this maintenance.">
          <mat-icon>calendar_month</mat-icon>
          {{ !asset_maintenance_schedule.schedule_start_at ? 'Set' : 'Change' }} Schedule *
        </button>

        <span *ngIf="asset_maintenance_schedule.schedule_start_at" class="text-muted">
          <strong>Schedule:</strong> {{ scheduleSummary }}
        </span>

        <span *ngIf="!asset_maintenance_schedule.schedule_start_at" class="text-danger">
          No recurring schedule has been configured.
        </span>
      </div>

      <div class="w-100"></div>
    </ng-container>

    <button
      mat-raised-button
      [disabled]="!f.valid || !isRecurringScheduleValid || !isNextDueAtValid || !isAutoCreateValid"
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      id="save_close_button"
      (click)="onSubmit(f)">
      <mat-icon>save</mat-icon>
      Save & Close
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="contractor_selector_button"
      (click)="onSelectContractor()"
      [matBadge]="asset_maintenance_schedule.contractor_account_id ? '1' : '0'"
      matTooltip="Select the {{ utils.getLangTerm('contractors.singular', 'Contractor').toLowerCase() }} you want the maintenance schedule to be associated with.">
      <mat-icon>engineering</mat-icon>
      {{ !asset_maintenance_schedule.contractor_account_id ? 'Select' : 'Change' }} {{ utils.getLangTerm('contractors.singular', 'Contractor') }}
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="vendor_selector_button"
      (click)="onSelectVendor()"
      [matBadge]="asset_maintenance_schedule.vendor_id ? '1' : '0'"
      matTooltip="Select the vendor you want the maintenance schedule to be associated with.">
      <mat-icon>store</mat-icon>
      {{ !asset_maintenance_schedule.vendor_id ? 'Select' : 'Change' }} Vendor
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="users_selector_button"
      (click)="onSelectUsers()"
      [matBadge]="'' + (asset_maintenance_schedule.user_ids ? asset_maintenance_schedule.user_ids?.length : 0)"
      matTooltip="Select the users you want the maintenance schedule to be associated with.">
      <mat-icon>account_circle</mat-icon>
      Users
    </button>

  </mat-dialog-actions>

</form>
